import React, { useState } from "react";
import { useEffect } from "react";
import Table from "react-bootstrap/Table";
import Swal from "sweetalert2";
import Header from "../components/header";
import "./pstyle.css";
import { performVerification } from "../commonFunc/verification";
import { BsArrowsFullscreen } from "react-icons/bs";
import { useSelector } from "react-redux";
import translations from "../locals/translation";
import { LuCircleChevronLeft } from "react-icons/lu";
import { IoIosSearch } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function Queries() {
  const state = useLocation();
  const navigate = useNavigate();
  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      // setSellanguage(language);
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const [queries, setQueries] = useState([]);
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [setMess] = useState("");
  const [originalData, setOriginalData] = useState([]);

  const [searchInput, setSearchInput] = useState("");

  async function fetchStatements() {
    setLoading(true);
    const data = state?.state?.statements;

    if (data?.status_code === 200) {
    } else if (data.status_code === 404) {
      Swal.fire(data?.message);

      return;
    } else {
      Swal.fire(t("Server Error"));

      return;
    }
    setStatements(data.data);
    setLoading(false);
  }

  async function fetchData() {
    const data = state.state.mainReports;

    if (data.status_code === 200) {
      setLoading(false);
    } else if (data.status_code === 404) {
      setMess(data.message);
      setLoading(false);
    } else {
      Swal.fire(t("Server Error"));
    }

    setQueries(data.data);
    setOriginalData(data.data);
    setLoading(false);
  }

  const formatDate = (createdAt) => {
    const date = new Date(createdAt);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTime = (createdAt) => {
    const date = new Date(createdAt);
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    return date.toLocaleTimeString("en-US", options);
  };

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    if (state.state == null || state.state === undefined) {
      navigate("/dashboard");
      return;
    }
    fetchStatements();
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchChange = (e) => {
    let data3 = originalData;
    const inputValue = e.target.value.toLowerCase().trim(); // Trim whitespace and convert to lowercase
    if (inputValue === "") {
      setQueries(originalData);
      setSearchInput("");
      return;
    }

    const result = data3.filter((item) =>
      Object.keys(item).some((key) => {
        if (typeof item[key] === "object" && item[key] !== null) {
          if (key === "truck") {
            return (
              item[key].truck_name.toLowerCase().includes(inputValue) ||
              item[key].username.toLowerCase().includes(inputValue) ||
              item[key].vendor.username.toLowerCase().includes(inputValue)
            );
          }
          if (key === "vendor") {
            return (
              item[key].username.toLowerCase().includes(inputValue) ||
              item[key].first_name.toLowerCase().includes(inputValue) ||
              item[key].last_name.toLowerCase().includes(inputValue)
            );
          }
        }
        // For non-object values or keys not 'truck' or 'vendor', search directly
        return (
          typeof item[key] === "string" &&
          item[key].toLowerCase().includes(inputValue)
        );
      })
    );

    if (result.length === 0) {
      setQueries([]);
    }
    setSearchInput(inputValue);
    setQueries(result);
  };

  return (
    <React.Fragment>
      <Header />
      <div className="dashboard-Container">
        <div className="body-container-dashboard">
          <div className="login-heading">
            <h1>{t("Queries")}</h1>
            <h5>
              {t(
                `Users and vendors queries are essential. We handle them promptly to ensure smooth communication.`
              )}
            </h5>
            <div className="input-with-search">
              {/* <input value={searchInput} onChange={(e) => { handleSearchChange(e) }} className="searchInput" /><IoIosSearch /> */}
              <div className="search-back">
                <LuCircleChevronLeft
                  fill="none"
                  className="back-button"
                  onClick={() => navigate("/dashboard")}
                />
                <div className="input-with-search">
                  <input
                    placeholder="search"
                    value={searchInput}
                    onChange={(e) => {
                      handleSearchChange(e);
                    }}
                    className="searchInput"
                  />
                  <IoIosSearch />
                </div>
              </div>
            </div>
            <div className="query-body">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="loading-spinner"></div>
                  <p className="logging-heading">{t("Loading")}</p>
                </div>
              ) : queries.length ? (
                <Table striped>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{t("Vendor Name")}</th>
                      <th>{t("Category")}</th>
                      <th>{t("Statement")}</th>
                      <th>{t("Date")}</th>
                      <th>{t("Time")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {queries.map((item, index) => {
                      const matchingStatement = statements.find(
                        (statement) => statement.id === item.msg_id
                      );
                      const statementValue = matchingStatement
                        ? matchingStatement.value
                        : "Not found";
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.vendor?.first_name}</td>
                          <td>{statementValue}</td>
                          <td>
                            {item.text ? (
                              <span>
                                {item.text.slice(0, 9) + "..."}
                                <BsArrowsFullscreen
                                  onClick={() => {
                                    Swal.fire({
                                      text: `${item.text}`,
                                      title: t("Report Statement"),
                                    });
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "20px",
                                  }}
                                />
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{formatDate(item.createdAt)}</td>
                          <td>{formatTime(item.createdAt)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <p className="NdF">{t("No Queries Found")}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </React.Fragment>
  );
}

export default Queries;
